// extracted by mini-css-extract-plugin
export default {"title":"Article_title__cnzh+"};